import { Link } from 'react-router-dom';

import { Anchor, Text } from '@mantine/core';

import classes from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={classes.bar}>
      <Text size="xs" c="dimmed">
        © {year} Ground Truth Intelligence
      </Text>
      <Anchor component={Link} to="/sources" size="xs" c="dimmed">
        Data Sources
      </Anchor>
    </footer>
  );
}
